import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, EventEmitter} from '@angular/core';
import { Observable } from 'rxjs';
import { datosFacturacion } from '../entities/datosFacturacion';
import { CFDI } from '../entities/cdfi';
import { RFiscal } from '../entities/regimenFiscal';

@Injectable({
  providedIn: 'root'
})
export class DatosFacturacionService {
  private headers: HttpHeaders
  public modalSwitch: boolean;
  $modal = new EventEmitter<any>();

  constructor(private http: HttpClient) { }

  obtenerListaDatos(): Observable<datosFacturacion[]> {
		return this.http.get<datosFacturacion[]>(`${environment.API_SECURITY}/api/Facturacion/DireccionFacturacion`);
	}
  
  guardarDatos(data) {
    return this.http.post(environment.API_SECURITY+'/api/Facturacion/DireccionFacturacion',data)
  }
  

  actualizarDatos(formData): Observable<any> {
		return this.http.put<any>(environment.API_SECURITY + '/api/Facturacion/direccion', formData);
	} 

  facturacionInvitado(formData): Observable<any> {
		return this.http.put<any>(environment.API_SECURITY + '/api/facturacion/DireccionFacturacionInvitado', formData);
	} 
  
  eliminarDatos(id: Number) {
		return this.http.delete(environment.API_SECURITY + '/api/Facturacion/direccion/' + id);
	}

  listarCFDI(): Observable<CFDI[]> {
		return this.http.get<CFDI[]>(`${environment.API_SECURITY}/api/Facturacion/catalogoCFDI`);
	}

  listarRegimenFiscal(): Observable<RFiscal[]> {
		return this.http.get<RFiscal[]>(`${environment.API_SECURITY}/api/Facturacion/catalogoRegimenFiscal`);
	}

  // listarRegimenFiscal(): Observable<RFiscal[]> {
	// 	return this.http.get<RFiscal[]>(`https://bestticket.com.mx/BestTicket/bestticketapi/api/Facturacion/catalogoRegimenFiscal`);
	// }
  
  obtenerDatosById(id:number):Observable<any>{
    return this.http.get<any>(environment.API_SECURITY+'/api/Facturacion/direccion/'+id)
  }
  
  verificarRFC(RFC:string):Observable<any>{
    return this.http.get<any>(environment.API_SECURITY+'/api/facturacion/direccionRFC/'+ RFC);
  }
  
  facturar(data) {
    return this.http.post(environment.API_SECURITY+'/api/Facturacion',data)
  }


}
